<template>
  <div class="flex-col item-height">
    <div class="flex-row title-info"
      v-if="false">
      <label class="link-info">{{ $t('peLink') }}</label>
      <van-dropdown-menu v-if="false">
        <van-dropdown-item v-model="langValue"
          :options="languageOption"
          disabled
          @change="changeLanguage" />
      </van-dropdown-menu>
    </div>
    <van-image height="148px"
      fit="fill"
      src="/src/assets/imgs/overview.jpg" />

    <div class="tips-info">
      <span class="tips-item">{{ greetings}}</span>
      <span class="tips-item1">{{ userInfo.englishName }}</span>
    </div>
    <div class="list-info">

      <van-tabs v-model="active">
        <van-tab v-for="m in menus"
          :key="m.id"
          :title="m.title">
          <van-tabs v-if="m.subMenus.length>1"
            class="inner-tab">
            <van-tab v-for="subm in m.subMenus"
              :key="subm.id"
              :title="subm.title">

              <tab-list ref="tabMarket"
                :news-type="subm.id"
                :relation-id="subm.id"></tab-list>
            </van-tab>
          </van-tabs>
          <tab-list v-if="m.subMenus.length==1"
            ref="tabMarket"
            :news-type="m.subMenus[0].id"
            :relation-id="m.subMenus[0].id"></tab-list>
        </van-tab>
        <van-tab title="其他新闻">
          <tab-list ref="tabNews"
            :news-type="0"></tab-list>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import webService from "@/network/webService";
import _ from 'lodash';
import common from '@/common/common';
import NewsList from './NewsList.vue';
import TabList from './TabList.vue';
import SearchPanel from '@/components/common/SearchPanel.vue';
import loginInfo from "../../common/loginInfo";
import scollerLocation from '@/common/scollerLocation'
import { install } from 'vant';
export default {
  name: 'Overview',
  components: {
    NewsList,
    TabList,
    SearchPanel,
  },
  data () {
    return {
      greetings: '上午好',
      userInfo: {},
      languageOption: [{
        text: '中文',
        value: 'cn'
      },
      {
        text: 'EN',
        value: 'en'
      },
      ],
      langValue: 'cn',
      menus: [
      ],
      active: 0,
      newsType: 0,
      active_sub: 0,
      active_sub2: 0,
      searchValue: '',
      searchValueNews: '',
      showSearchPanelNews: false,
      showSearchPanel: false,
      searchPanelTypeNews: common.searchTypeEnum.newsType,
      searchPanelType: common.searchTypeEnum.marketPeriod,
      value1: 0,
      value2: 'a',
      option1: [
        { text: '国内新闻', value: 0 },
        { text: '国际新闻', value: 1 },
        { text: '活动商品', value: 2 },
      ],
      option2: [
        { text: 'tab1', value: 'a' },
        { text: 'tab2', value: 'b' },
      ],
    };
  },
  created () {
    let userId = null;
    webService.getUserProfileInfo(userId).then((r) => {
      this.userInfo = r.data;
      loginInfo.userInfo = this.userInfo;
    });
    this.initGreetings();

    setInterval(() => {
      // console.log('interval ....................');
      this.initGreetings();
    }, 1000);
    this.getMenusList(true);
  },
  activated () {
    this.initGreetings();
    for (let i = 0; i < this.menus.length; i++) {
      const menu = this.menus[i];
      for (let j = 0; j < menu.subMenus.length; j++) {
        const sub = menu.subMenus[j];
        let id = 'cont-list-' + sub.id;
        scollerLocation.recoverLocation(id);
      }
    }
    scollerLocation.recoverLocation('cont-list-news');
  },
  beforeRouteLeave (to, from, next) {
    debugger;
    for (let i = 0; i < this.menus.length; i++) {
      const menu = this.menus[i];
      for (let j = 0; j < menu.subMenus.length; j++) {
        const sub = menu.subMenus[j];
        let id = 'cont-list-' + sub.id;
        var list = document.querySelector('#' + id);
        if (list) {
          scollerLocation.saveLocation(id, list);
        }
      }
    }

    var newsList = document.querySelector('#cont-list-news');
    if (newsList) {
      scollerLocation.saveLocation('cont-list-news', newsList);
    }
    next();
  },
  methods: {
    initGreetings () {
      const date = new Date();
      if (date.getHours() >= 6 && date.getHours() < 12) {
        this.greetings = '上午好'
      } else if (date.getHours() >= 12 && date.getHours() < 18) {
        this.greetings = '下午好'
      } else {
        this.greetings = '晚上好'
      }
    },
    getMenusList (init) {
      webService.getMenusList().then((res) => {
        if (res.data.success) {
          console.log(res.data);
          let dataList = res.data.data;
          this.menus = dataList;
          // if (init && dataList.length > 0) {
          //   this.activeTab = dataList[0].title;
          // }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    tabChange () {
      switch (this.active) {
        case 0:
          this.searchPanelType = common.searchTypeEnum.newsType;
          break;
        case 1:
          this.searchPanelType = common.searchTypeEnum.marketPeriod;
          break;
      }
    },
    changeLanguage () { },

    showSearch () {
      if (this.active == this.menus.length) {
        this.showSearchPanelNews = true;
      } else {
        this.showSearchPanel = true;
      }
    },
    searchByPanel (searchParams) {
      if (searchParams.hasFilter) {
        document.getElementById('overview-filter').classList.add('has-filter');

      } else {
        document.getElementById('overview-filter').classList.remove('has-filter');
      }
      debugger;
      if (this.active == this.menus.length) {

        this.$refs.tabNews.searchData(searchParams);
      } else {
        this.$refs.tabMarket[this.active].searchData(searchParams);
      }
      this.showSearchPanelNews = false;
      this.showSearchPanel = false;
    },
  },
};
</script>


<style lang="scss" scoped>
/deep/ .van-tabs__line {
  background-color: #c52a1a;
}
.tips-info {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 50px;
  left: 20px;
  color: white;
  font-size: 25px;
}
.tips-item {
  background-color: black;
  width: 80px;
  padding: 5px;
}
.tips-item1 {
  background-color: black;
  padding: 5px;
}
.title-info {
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem 0 1rem;
  border-width: 0 0 2px 0;
  border-style: solid;
  border-color: #ececec;
}
.link-info {
  font-size: 18px;
  color: #2d2d2d;
  padding: 8px 0;
}
.list-info {
  height: calc(100% - 150px);
}
.list-heigt {
  height: 100%;
}
/deep/ .van-dropdown-menu__bar {
  box-shadow: none;
}
/deep/ .van-tabs__content {
  height: calc(100% - 50px);
}
/deep/ .van-tab__pane {
  height: 100%;
}
/deep/ .van-tabs__wrap {
  height: 50px;
}
/deep/ .van-tab--active {
  color: #c52a1a;
}
.item-info {
  padding: 0.6rem 1rem 0.5rem 1rem;
}
.sort-style {
  position: absolute;
  right: 12px;
  top: 166px;
  z-index: 1;
  height: 40px;
  color: #7d7d7d;
}
.split-info {
  height: 1px;
}
/deep/ .van-tabs {
  height: 100%;
}
/deep/ .van-dropdown-menu__title::after {
  right: 2px;
}
// /deep/ .van-tab {
//   flex: none;
//   min-width: 66px;
// }
/deep/ .van-tabs__wrap {
  height: 46px;
}
/deep/ .van-tabs__nav--line {
  padding-bottom: 14px;
}
.inner-tab /deep/ .van-tab {
  flex: 1;
  // height: 36px;
}
.inner-tab /deep/ .van-tab__text {
  font-weight: normal;
  font-size: 14px;
}
.inner-tab /deep/ .van-tabs__wrap {
  height: 36px;
}
.inner-tab /deep/ .van-tab--active {
  color: white;
  background-color: #c52a1a;
}
.inner-tab /deep/ .van-tabs__line {
  display: none;
}
.inner-tab /deep/ .van-tabs__content {
  border-top: none;
  margin-top: 0;
}
/deep/ .van-tab__text {
  font-weight: bolder;
  font-size: 16px;
}
/deep/ .van-tabs__content {
  border-top: 1px solid #dedede;
  margin-top: 4px;
}
</style>


// WEBPACK FOOTER //
// src/views/overview/OverView.vue